import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Delete , Check, Close} from "@material-ui/icons";
import axios from "axios";

export default class DeleteED extends Component {
  constructor(props) {
    super();
    this.state = {
      showDeleteModal: false,
      disableSubmit: false,
    };
    this.handleshowDeleteModal = this.handleshowDeleteModal.bind(this);
  }

  handleshowDeleteModal = (e) => {
    this.setState({ showDeleteModal: !this.state.showDeleteModal });
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableSubmit: true });
    axios.post("api/delete_earning_deduction/" + this.props.edData.id, {active:this.props.edData.active}).then((res) => {
      this.props.parentCallback(true);
      this.setState({ showDeleteModal: false, disableSubmit: false });
    });
  };

  render() {
    return (
      <>
        <button
          className={(this.props.edData.active == 1)?("btn btn-outline-danger btn-sm float-right"):("btn btn-outline-info btn-sm float-right")}
          title={(this.props.edData.active == 1)?("Inactive Earning/Deduction"):("Activate Earning/Deduction")}
          onClick={this.handleshowDeleteModal}
        >
          {(this.props.edData.active == 1)?(<Close />):(<Check />)}
          
        </button>
        <Modal
          size="md"
          backdrop="static"
          show={this.state.showDeleteModal}
          onHide={() =>
            this.setState({ showDeleteModal: !this.state.showDeleteModal })
          }
        >
          <Modal.Header closeButton>
            <h4>{(this.props.edData.active == 1)?("Inactive"):("Activate")} Earning/Deduction : {this.props.edData.name}</h4>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  Are you sure?
                </div>
              </div>
              <div className="float-right">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                  disabled={this.state.disableSubmit}
                >
                  {(this.props.edData.active == 1)?("Inactive"):("Activate")}
                </button>
                <button
                  onClick={this.handleshowDeleteModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
